import { Button, Icon, icons, Typography, theme } from "cdh-data-portal-theme"
import { getSignOutUrl } from "../../../api/authenticationApi"
import { useStyles } from "./NotAuthorized.style"
import { localText } from "./NotAuthorized.static"

/**
 * Shown when a signed-in user has no role from an allowed ops-hub account (see
 * config/accounts.ts / api/authorizationApi.ts). This gate only blocks the UI -- the backend
 * must independently authorize every operation regardless of what the frontend shows.
 */
export const NotAuthorized: React.FC = () => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Icon
          iconPath={{ path: icons.portalLogo.path, viewBox: "0 0 64 64" }}
          color={theme.colors.primary}
          size={40}
        />
        <Typography variant="headline2" className={classes.title}>{localText.title}</Typography>
        <Typography variant="body" className={classes.subtitle} color={theme.textColors.primaryLighter}>
          {localText.subtitle}
        </Typography>
        <Button
          url={getSignOutUrl()}
          openLinkInNewTab={false}
          variant="secondary"
          title={localText.signOutButton}
          width={260}
        />
      </div>
    </div>
  )
}

export default NotAuthorized
